module.exports = __webpack_public_path__ + "img/V-L-6-unload-standup-shadow.132106f1.png";